var $ = global.jQuery
    , ko                 = require('knockout')
    , core               = require('CoreModule')
    , events             = core.Events
    , moment             = core.Moment
    , Guid               = core.Guid   
    , controllerEvents   = require('ControllerEvents.js')
    , helpers            = core.Helpers
    , tree               = require('tree/tree.js')
    , isInternetExplorer = global.isInternetExplorer;
    

var ProcessEveryChange = false;
var LastSelectedFilterFieldName;
var AnySelectedSinceOpening;
var formattedSelection       = function(selection){ return _(selection).map(helpers.unNbsp).join('\n') }
var clearAllTypeaheads       = function(){ $('input.typeahead').typeahead('val', '') }
var clearTypeaheadFromCousin = function(element) { $(element).parents('.FilterRoot').find('input.typeahead').typeahead('val', '') }
var clearTypeaheadFromFilter = function(filter)  { $("div[data-filter-id='" + filter._id + "']") .find('input.typeahead').typeahead('val', '') }

ko.bindingHandlers.cascade_options = {
    init: function(element, valueAccessor, allBindings, _filter, bindingContext) {


        var bindings       = allBindings()
        , targetObservable = _filter.FilterValues
        , updater          = bindings.onUpdate
        , cascadeSetName   = _filter.CascadeSetName
        , fieldName        = _filter.FieldName
                
        if(!targetObservable) throw 'expected values binding';

        console.log('set-uppp' , fieldName);

        var selected      = targetObservable()
        , options         = ko.unwrap(valueAccessor());



        _filter.isOpen = false;

        var setValues = function(selected){

            var thoseSelected = _.split(selected, ','); 
            
            return (_.some(thoseSelected) ? thoseSelected : ['loading... '])
            
            .map(function(o){ return '<option>' + o + '</option>' } ).join('')

         }

         var setEnableState = function () {

            var enabled = _filter.Enabled() && !_filter.optionsCountExceeded()
            ,   message = enabled ? 'Nothing selected' : '-N/A-'
            
            $(element)
            .selectpicker({ noneSelectedText : message })
            .selectpicker('refresh')
            .siblings('button.btn.dropdown-toggle')
            .toggleClass('disabled',!enabled);

            return $(element);
        }

        targetObservable.subscribe(function(newSelection){

            console.log('new selection' , newSelection, '###########################', $(element), _filter.isOpen ? 'open' : 'closed');

            if(!_filter.isOpen){

                var options = ko.unwrap(valueAccessor());
                var count   = _.size(options);
                                                    
                console.log(_filter.renderedCount, count);
                
                if(_filter.renderedCount !== count){
                
                    $(element)
                    .html(setValues(newSelection))
                    //.selectpicker('refresh')
                    setEnableState();
                }

                $(element)                                            
                .selectpicker('val', newSelection);
                setEnableState()
                .siblings('button.btn.dropdown-toggle')
                .attr('title', formattedSelection(newSelection) );   

                _.isFunction(updater) && updater(cascadeSetName);
                
            }
            //return true;
        })

        $(element).html(setValues(selected));
       
        $(element)
        .selectpicker({
            style            : 'btn-default',
            size             : 6,
            tickIcon         : 'glyphicon-triangle-right', // ''
            virtualScroll    : 400
        })
        .selectpicker('val', selected)
        .selectpicker('refresh');
        


        _filter.Enabled             .subscribe(setEnableState);
        _filter.optionsCountExceeded.subscribe(setEnableState);

        $(element)
        .on('changed.bs.select', _.throttle(function (e) {

            LastSelectedFilterFieldName = fieldName;
            AnySelectedSinceOpening     = true;

            console.log('.on(\'changed.bs.select\'',  e, fieldName, element, $(element));

            var newValue =  _(e.target.options).filter( 'selected' ).map('value').value();
            if( JSON.stringify(newValue) === _filter.oldValue){
                e.stopPropagation();
                return
            }
            _filter.oldValue             = JSON.stringify(newValue);

            (targetObservable() !== newValue) && targetObservable(newValue);
            console.log('~#~#~' , fieldName);     
            return true;      
        }, 400))
        .on('show.bs.select'	 , function (e) { //console.log('This event fires immediately when the show instance method is called.                                                       ') 

                                                    AnySelectedSinceOpening = false;

                                                    _filter.isOpen = true;

                                                    var options = ko.unwrap(valueAccessor());
                                                    selected         = targetObservable();
                                                    var count   = _.size(options);
                                                    
                                                    const delta       = isInternetExplorer ? 10 : 9999; // inserts per itteration
                                                    const interval    = 100;                              // ms itteration interval
                                                    const overRunTest = 88888; 

                                                    console.log(_filter.renderedCount, count);
                                                    
                                                    if(_filter.renderedCount !== count){

                                                        _filter.renderedCount = count;

                                                        if(count > 100) _filter.busy(true);

                                                        var things = options, start = -99, end = delta

                                                        , id = setInterval(function () {

                                                            if(start === -99){

                                                                console.log(' Step 1 - clear');

                                                                $(element).empty();

                                                                start = 0;
                                                                
                                                                return;
                                                            } 
                                                            
                                                            var taken = _.slice(things, start, end); start = end; end += delta;

                                                            if(!_.some(taken) || end > overRunTest) {  
                                                                
                                                                $(element).selectpicker('val', selected).selectpicker('refresh');

                                                                console.log(' Step X - finish', start, end);
                                                                
                                                                clearInterval(id); 
                                                                
                                                                _filter.busy(false);

                                                                return;
                                                            }
                                                            
                                                            var inserts = _(taken).map(function(o){ return '<option>' + o + '</option>' } ).join('');
                                                            
                                                            console.log(' Step N - finish', start, end, inserts);
                                                            
                                                            
                                                            
                                                            $(element).append(inserts);
                                                            setEnableState();
                                                            
                                                            //.selectpicker('refresh');
                                                            

                                                        
                                                            var outter = $(element).siblings('div.dropdown-menu.open');
                                                            var inner = outter.find('ul.dropdown-menu.inner');

                                                            console.log('outer inner', outter.height(), inner.height());

                                                            var LastSelectedFilterHeight = outter.height();


                                                            if(isInternetExplorer){
                                                                
                                                                inner.css({ maxHeight:150, height:150, overflowY: 'auto' });   
                                                                outter.css({ maxWidth:303})
                                                            }
                                                            else{
                                                                inner.css({ maxHeight:150, height:150, overflowY: 'auto' });   
                                                            }                                                        

                                                        }, interval)
                                                        
                                                    }

                                                    

                                                } )                                         
        .on('shown.bs.select'	 , function (e) { //console.log('This event is fired when the dropdown has been made visible to the user (will wait for CSS transitions, to complete).       ') 
        
                                                } )         
        .on('hide.bs.select'	 , function (e) { //console.log('This event is fired immediately when the hide instance method has been called.                                              ') 
    
                                                    _filter.isOpen = false;
                                                    AnySelectedSinceOpening && _.isFunction(updater) && updater(cascadeSetName);
                                                
                                                } )     
//      .on('hidden.bs.select'	 , function (e) { console.log('This event is fired when the dropdown has finished being hidden from the user (will wait for CSS transitions, to complete). ') } )     
        .on('loaded.bs.select'	 , function (e) { //console.log('This event fires after the select has been initialized.                                                                     ');

                                    } )     
//      .on('rendered.bs.select' , function (e) { console.log('This event fires after the render instance has been called.                                                                 ') } )     
//      .on('refreshed.bs.select', function (e) { console.log('This event fires after the refresh instance has been called.                                                                ') } )     
//      .on('changed.bs.select'	 , function (e) { console.log('This event fires after the selects value has been changed. It passes through event, clickedIndex, newValue, oldValue.       ') } )     
    }
};




ko.bindingHandlers.multi_options = {
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {


        var bindings       = allBindings()
        , targetObservable = bindings['values']
        , updater          = bindings['onUpdate']
        , cascadeSetName   = ko.unwrap(bindings['cascadeSetName'])
        , fieldName        = ko.unwrap(bindings['fieldName'])
                
        if(!targetObservable) throw 'expected values binding';

        //console.log('set-uppp' , fieldName);

        $(element)
        .on('changed.bs.select', function (e) {

            LastSelectedFilterFieldName = fieldName;
            AnySelectedSinceOpening     = true;

           // console.log('bolalmo hnewe', fieldName, element, $(element));
            var outter = $(element).siblings('div.dropdown-menu.open');
            var inner = outter.find('ul.dropdown-menu.inner');
            LastSelectedFilterHeight = inner.height();
          //  console.log('outter', outter, LastSelectedFilterHeight);


            targetObservable( _(e.target.options).filter( 'selected' ).map('value').value() );
            ProcessEveryChange && _.isFunction(updater) && updater(cascadeSetName);
            //console.log('~#~#~' , fieldName);           
        })
        .on('show.bs.select'	 , function (e) { //console.log('This event fires immediately when the show instance method is called.                                                       ') 

                                                    AnySelectedSinceOpening = false;
                                                } )                                         
        .on('shown.bs.select'	 , function (e) { //console.log('This event is fired when the dropdown has been made visible to the user (will wait for CSS transitions, to complete).       ') 
        
                                                } )         
        .on('hide.bs.select'	 , function (e) { //console.log('This event is fired immediately when the hide instance method has been called.                                              ') 
    
                                                    ProcessEveryChange || AnySelectedSinceOpening && _.isFunction(updater) && updater(cascadeSetName);
                                                
                                                } )     
//      .on('hidden.bs.select'	 , function (e) { console.log('This event is fired when the dropdown has finished being hidden from the user (will wait for CSS transitions, to complete). ') } )     
        .on('loaded.bs.select'	 , function (e) { //console.log('This event fires after the select has been initialized.                                                                     ');

                                                    if(ProcessEveryChange && LastSelectedFilterFieldName && (fieldName === LastSelectedFilterFieldName)){
           
                                                        console.log('Reopen', fieldName, element, $(element));
                                                        $(element).selectpicker('show'); // Regression in Bootstrap Select Module - doesn't work
                                                        $(element).parent().addClass('open'); 

                                                        var outter = $(element).siblings('div.dropdown-menu.open'); 
                                                        var inner = outter.find('ul.dropdown-menu.inner');                                                        
                                                        inner.css({ height:LastSelectedFilterHeight, overflowY: 'auto' });

                                                        LastSelectedFilterFieldName = null;
                                                    } 
                                    } )     
//      .on('rendered.bs.select' , function (e) { console.log('This event fires after the render instance has been called.                                                                 ') } )     
//      .on('refreshed.bs.select', function (e) { console.log('This event fires after the refresh instance has been called.                                                                ') } )     
//      .on('changed.bs.select'	 , function (e) { console.log('This event fires after the selects value has been changed. It passes through event, clickedIndex, newValue, oldValue.       ') } )     
    },
    update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

        var bindings       = allBindings()
        , targetObservable = bindings['values']
        , selected         = targetObservable()
        , fieldName        = ko.unwrap(bindings['fieldName']);

        var options = ko.unwrap(valueAccessor());
        
        $(element)
        .html(_(options).map(function(o){ return '<option>' + o + '</option>' } ).join(''))
        .selectpicker({
            style            : 'btn-default',
            size             : 6,
            noneSelectedText : ko.unwrap(bindings['enable']) ? 'Nothing selected' : '-N/A-',
            tickIcon         : 'glyphicon-triangle-right', // ''
        })
        .selectpicker('val', selected)
        .selectpicker('refresh')
        ;
        
       // console.log('uppddaatte' , fieldName);       
    }
};



var PictureFiltersViewModel = function (init) {

    global.diagnostics.pictureFiltersViewModel = global.ViewModel = this;

    var self                    = this;
    self.InterControllerEmitter = init.InterControllerEmitter;
    self.GalleryKey             = init.GalleryKey;
    self.helpers                = helpers;
    self.isInternetExplorer     = isInternetExplorer;

    self.busy            = ko.observable();
    self.reloading       = ko.observable();
    self.resetObservable = ko.observable();
    self.galleryFilters  = ko.observableArray();
    //Once gallery details have been loaded and primary date field is known, the field is used to populate this separate filter collection (only has this date field for now)
    self.galleryPrimaryFilters  = ko.observableArray();
    self.GalleryDetails  = ko.observable(init.GalleryDetails2);

    self._lastSelectedFilterFieldName = 'not-set';

    self.lastPrimaryStartUsed = ko.observable();
    self.lastPrimaryEndUsed = ko.observable();

    self.GetFilter = function(filterName){ 
    
        console.error('Get filter', filterName);    

        return _.find(self.galleryFilters(), { FieldName: filterName }) || { FilterValues : _.noop };
    }

    var galleryDetails = init.GalleryDetails2;
    self.galleryStartDate = galleryDetails && galleryDetails.GalleryStartDate ? moment(galleryDetails.GalleryStartDate).format('DD-MM-YYYY') : null;

    console.log('PictureFiltersViewModel', init, self);

    var distribePanels = helpers.makeVerticalDistribute([$('#filterTopPanel'),$('#filterButtonPanel'),$('#primaryFilterButtonPanel'),$('#primaryFiltersPanel')], $('#filtersPanel'));

    var dropdownResize = function(){
        
        $('.dropdown-menu.open').each(function(i,e){ 
            
            var list = $(e), parentWidth = list.parent().width();
    
            list.width(parentWidth);
        })
    }

    var fixNonBreakingSpacesInFilterToolTips = function () {

        $('.dropdown-toggle').each(function(i,e){ 
            
            var element = $(e), fixed = formattedSelection(_.split(element.attr('title'),', ')); 
            
            element.attr('title', fixed );         
        })
    }

    var resizeHandler = function (info) {

        distribePanels(info);
        dropdownResize();
    }

    var storageProvider = ko.storage.createStorageProvider('filters', init.GalleryKey, 7 * 24 * 60 * 60000);

    var createFilterKeyValuePair = function(nthFilter, filterValue){

        //if(!filterValue) return;

        var filterData = {}
        ,   fieldName  = nthFilter.FieldName;
        

        if (nthFilter.IsRangeFilter) {
            var rangeStart = nthFilter.RangeStart(),
                rangeEnd   = nthFilter.RangeEnd();

            if (rangeStart && rangeStart != "") {
                if (nthFilter.DataType === 'Date') {
                    rangeStart = moment(rangeStart, 'DD-MM-YYYY').format('YYYY-MM-DD');
                }
                var fieldRangeStartKey = fieldName + '__$RANGESTART__';
                filterData[fieldRangeStartKey] = rangeStart;
            }
            if (rangeEnd && rangeEnd != "") {
                if (nthFilter.DataType === 'Date') {
                    rangeEnd = moment(rangeEnd, 'DD-MM-YYYY').format('YYYY-MM-DD');
                }
                var fieldRangeEndKey = fieldName + '__$RANGEEND__';
                filterData[fieldRangeEndKey] = rangeEnd;
            }
        } else {
            if (filterValue && filterValue != "") {
                filterData[fieldName] =  helpers.unNbsp(filterValue);
            }
            else return;
        }

        return filterData;
    }    

    , mapFilter = function(nthFilter){

        return _.some(nthFilter.FilterValues()) 
                    ? _.map(nthFilter.FilterValues(), _.bind(createFilterKeyValuePair, _, nthFilter) )
                    : createFilterKeyValuePair(nthFilter, nthFilter.FilterValue());
    }
    , keyValuePair = function(obj){ return _.transform(obj, function(result, value, key) {
        result.push( { 'Key' : key , 'Value' : value } ) }, [] ) }
    
    self.findPictures = function () {
        console.error('OK Google - find me some pictures!');

        var filterData     = _(self.galleryFilters().concat(self.galleryPrimaryFilters())).flatMap(mapFilter).compact().flatMap(keyValuePair).value()
        ,   transportReady = JSON.stringify(filterData || []);
        console.error('transportReady', transportReady);
        events.emitter.emit(events.find_pictures, transportReady);
        self.busy(true);
    }

    self.applyPrimaryFilters = function () {
        console.error('Apply primary filters');

        var filterData     = _(self.galleryPrimaryFilters()).flatMap(mapFilter).compact().flatMap(keyValuePair).value()
        ,   transportReady = JSON.stringify(filterData || []);
        console.error('blah: primary transportReady', transportReady);
        events.emitter.emit(events.gallery_filters_requested, transportReady);
        self.busy(true);
    }

    events.emitter.on(events.view_mode_change, self.findPictures);

    var onInit = (function () {

        console.error('filters view (asdf)', self, JSON.stringify(init));

        events.emitter.on(events.resize, resizeHandler);

        
        self.InterControllerEmitter.removeAllListeners(controllerEvents.gallery_page_data_loaded);
        self.InterControllerEmitter.on(controllerEvents.gallery_page_data_loaded, function () { self.busy(false) });

        self.InterControllerEmitter.removeAllListeners(controllerEvents.gallery_filters_loaded);
        self.InterControllerEmitter.on(controllerEvents.gallery_filters_loaded, function (filters, mappings) {
            self.rememberPrimaryDateFilterValues();


            console.warn('filters loaded', filters);
            console.warn('mappings loaded', mappings);

            self.cascadeSetNames = tree.CascadeSetNamesFromFilters(filters); 
            
            self.cascadeSets = _(self.cascadeSetNames).map(function (cascadeName) {
                
                var mapping = _.find(mappings,{ name: cascadeName });
    
                console.warn('mapping selected', mapping);
                
                return tree.prepare(filters, mapping, cascadeName);

            }).value();
                 
            _.each(filters, function (filter) { 
                
                var autoCompleteSource = (filter.RenderingType === 'TypeAhead')
                                         ?  global.apiEndpoint + "/gallery/listfiltervalues?galleryKey=" + self.GalleryKey + "&fieldName=" + filter.FieldName + "&filterMask=%QUERY&primaryDateFilterField=" + self.GalleryDetails().PrimaryDateFilterField + "&visitDateFrom=" + moment(self.lastPrimaryStartUsed(), 'DD/MM/YYYY').format('YYYY-MM-DD') + "&visitDateTo=" + moment(self.lastPrimaryEndUsed(), 'DD/MM/YYYY').format('YYYY-MM-DD') + "&resultLimit=10"
                                         :  '';
                
                _.assign(filter, {
                 _id                 : Guid.create().toString().toUpperCase()
                ,FilterValue         : ko.observable().extend(storageProvider.setPropertyName('SecondaryFilters.' + filter.FieldName + '.FilterValue'))
                ,FilterValues        : ko.observableArray().extend(storageProvider.setPropertyName('SecondaryFilters.' + filter.FieldName + '.FilterValues'))
                ,FixedValuesCount    : ko.observable()
                ,RangeStart          : ko.observable().extend(storageProvider.setPropertyName('SecondaryFilters.' + filter.FieldName + '.RangeStart'))
                ,RangeEnd            : ko.observable().extend(storageProvider.setPropertyName('SecondaryFilters.' + filter.FieldName + '.RangeEnd'))
                ,AutoCompleteSource  : autoCompleteSource
                ,RemoteFilter        : function (response) {return response.Content}
                ,Enabled             : ko.observable(true) 
                ,CascadeSetName      : tree.cascadeSetNameFromFilter(filter, self.cascadeSets)
                ,busy                : ko.observable()
                ,optionsCountExceeded: ko.observable()
            }) });

            self.galleryFilters(init.CachedFilters(filters));

            
            
            _.each(self.cascadeSets,function (set) {
                
                var filtersForSet = _.filter(filters, { CascadeSetName: set.name  });
                console.log('filters filterd by set', set.name, filtersForSet);
                set.galleryFilters = ko.observableArray(filtersForSet);
                // _.assign(set, { galleryFilters: filtersForSet }) 
            
            });

            self.cascade();   

            self.busy(false);

        });


        // if (self.InterControllerEmitter.listenerCount(controllerEvents.primary_filters_loaded) < 1)
        // {
        //RM: Would rather 'add if not in already' rather than removeallfirst but seems there is some state bundled into the function that causes bugs when not rebuilt.
        self.InterControllerEmitter.removeAllListeners(controllerEvents.primary_filters_loaded);
        self.InterControllerEmitter.on(controllerEvents.primary_filters_loaded, function (primaryFilters, galleryKey) {

            console.warn('blah: primary filters loaded');
            _.each(primaryFilters, function (filter) {
                var autoCompleteSource = (filter.RenderingType === 'TypeAhead')
                                        ?  global.apiEndpoint + "/gallery/listfiltervalues?galleryKey=" + galleryKey + "&fieldName=" + filter.FieldName + "&filterMask=%QUERY&resultLimit=10"
                                        :  '';
                
                _.assign(filter, {
                _id                 : Guid.create().toString().toUpperCase()
                ,FilterValue         : ko.observable().extend(storageProvider.setPropertyName('PrimaryFilters.' + filter.FieldName + '.FilterValue'))
                ,FilterValues        : ko.observableArray().extend(storageProvider.setPropertyName('PrimaryFilters.' + filter.FieldName + '.FilterValues'))
                ,FixedValuesCount    : ko.observable()
                ,RangeStart          : ko.observable().extend(storageProvider.setPropertyName('PrimaryFilters.' + filter.FieldName + '.RangeStart'))
                ,RangeEnd            : ko.observable().extend(storageProvider.setPropertyName('PrimaryFilters.' + filter.FieldName + '.RangeEnd'))
                ,AutoCompleteSource  : autoCompleteSource
                ,RemoteFilter        : function (response) {return response.Content}
                ,Enabled             : ko.observable(true) 
                ,CascadeSetName      : tree.cascadeSetNameFromFilter(filter, self.cascadeSets)
                ,busy                : ko.observable()
                ,optionsCountExceeded: ko.observable()
            }) });


            var primaryDateFilterField = self.GalleryDetails().PrimaryDateFilterField;
            if(!self.hasPrimaryStartDate(primaryFilters) && !self.hasPrimaryEndDate(primaryFilters))
            {
                _(primaryFilters).find(x => x.FieldName === primaryDateFilterField).RangeStart(moment(moment().add(-(self.GalleryDetails().DefaultStartDateOffset),'days').toDate(), 'DD/MM/YYYY').format('DD/MM/YYYY'));
                _(primaryFilters).find(x => x.FieldName === primaryDateFilterField).RangeEnd(moment(moment().toDate(), 'DD/MM/YYYY').format('DD/MM/YYYY'));
                
            }

            self.galleryPrimaryFilters(init.CachedPrimaryFilters(primaryFilters));


            dropdownResize();

            console.warn('blah: galleryfilters empty?', helpers.isEmptyArray(self.galleryFilters()));

            if(self.autoApplyPrimaryFilters(primaryFilters))
            {
                self.applyPrimaryFilters();
            }
        });
        // }


    })();

    var filterObservableNames = ['FilterValue', 'RangeStart', 'RangeEnd'];


    self.keepFilterTitleDropdownOpen = false;

    self.clearIndividualFilter = function (filter) {

        self.keepFilterTitleDropdownOpen = false;
        
        clearTypeaheadFromFilter(filter);
        
        filter.FilterValue(undefined).FilterValues.removeAll();
    }


    self.clearSpecificValue = function(specificValue, filter){

        self.keepFilterTitleDropdownOpen = _.size(filter.FilterValues()) > 1;

        clearTypeaheadFromFilter(filter);
        
        filter.FilterValues.remove(specificValue);
    }

    self.clearFilters = function () {

        console.log('self', self);

        _.each(filterObservableNames, function (observableName) {
            _.invokeMap(self.galleryFilters(), observableName, undefined);            
        })
        _(self.galleryFilters()).map('FilterValues').invokeMap('removeAll').value();

       self.resetObservable(true).resetObservable(false);

       clearAllTypeaheads();       

       self.cascade();
    }

    self.rememberPrimaryDateFilterValues = function () {
        self.lastPrimaryStartUsed(self.getPrimaryStartDate(self.galleryPrimaryFilters())); 
        self.lastPrimaryEndUsed(self.getPrimaryEndDate(self.galleryPrimaryFilters()));

    };
    
    self.hasFilters = ko.pureComputed(function () {

        return _(self.galleryFilters()).flatMap(mapFilter).compact().some();
    });

    self.getPrimaryStartDate = function (filterCollection) {
        var primaryDateFilterField = self.GalleryDetails().PrimaryDateFilterField;
        var filter = _(filterCollection).find(x => x.FieldName === primaryDateFilterField);
        if(filter)
        {return filter.RangeStart();}
        else
        {return undefined;}
    };

    self.getPrimaryEndDate = function (filterCollection) {
        var primaryDateFilterField = self.GalleryDetails().PrimaryDateFilterField;
        var filter = _(filterCollection).find(x => x.FieldName === primaryDateFilterField);
        if(filter)
        {return filter.RangeEnd();}
        else
        {return undefined;}
    };

    self.hasPrimaryStartDate = function (filterCollection) {
        return self.getPrimaryStartDate(filterCollection) !== undefined
    };
    self.hasPrimaryEndDate = function (filterCollection) {
        return self.getPrimaryEndDate(filterCollection) !== undefined
    };

    self.havePrimaryDatesChanged = ko.pureComputed(function () {
        return self.getPrimaryStartDate(self.galleryPrimaryFilters()) !== self.lastPrimaryStartUsed() || self.getPrimaryEndDate(self.galleryPrimaryFilters()) !== self.lastPrimaryEndUsed();
    });

    self.autoApplyPrimaryFilters = function (filterCollection) {
        return self.hasPrimaryStartDate(filterCollection);
    };

    self.glitchReset = ko.observable(true);
    
    self.onFiltersRendered = function (elements, data) {
          
          $(".dropdown.conditionalClose").on("hide.bs.dropdown", function(e, f) {
    
            var close = !self.keepFilterTitleDropdownOpen;

            self.keepFilterTitleDropdownOpen = false;

            return close;
          });
    }
    
    self.onPrimaryFiltersRendered = function (elements, data) {
          
        $(".dropdown.conditionalClose").on("hide.bs.dropdown", function(e, f) {
  
          var close = !self.keepFilterTitleDropdownOpen;

          self.keepFilterTitleDropdownOpen = false;

          return close;
        });
    }


    self.cascade = function(cascadeSetName){


        var sets = cascadeSetName ? _.filter(self.cascadeSets, { name : cascadeSetName }) : self.cascadeSets;

        _(sets)
    
            .flatMap(tree.cascade)
            .each(function (update) {

            var filter = _.find(self.galleryFilters(), { FieldName: update.name });

            filter.FixedFilterValues = update.filterNames; 
            filter.FixedValuesCount(_.size(filter.FixedFilterValues));
        })

         _(sets)
            .flatMap(tree.enabledUpdatesFromSet)
            .each(function (update) {
            
            var filter = _.find(self.galleryFilters(), { FieldName: update.name });
            
            filter && filter.Enabled(update.enabled);
        })

      //  self.glitchReset(false).glitchReset(true);

        dropdownResize();

        fixNonBreakingSpacesInFilterToolTips();
    }

    var reloadHandler            = _.bind(self.reloading, _, true);
    var repositoryChangesHandler = _.bind(self.reloading, _, false);    

    events.emitter.on(events.view_mode_change, reloadHandler);
    events.emitter.on(events.repository_changes, repositoryChangesHandler);

    PictureFiltersViewModel.prototype.dispose = function () {
        console.error("Disposing PictureFiltersViewModel....");
        events.emitter.removeListener(events.resize, resizeHandler);
        events.emitter.removeListener(events.view_mode_change, reloadHandler);
        events.emitter.removeListener(events.repository_changes, repositoryChangesHandler);
    }
    events.emitter.emit(events.picture_filters_view_initialized);

}

module.exports = {
    viewModel: PictureFiltersViewModel
    , template: require('PictureFiltersView.html')
    , title: 'Call Page'

};